import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './assets/languages/en.json';
import vi from './assets/languages/vi.json';

// const currentLocale = Intl.DateTimeFormat().resolvedOptions().locale;
// console.log({ currentLocale });

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        lng: "vi",
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        // lng: 'cimode',
        resources: {
            en: { translation: en },
            vi: { translation: vi },
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;